import {Button, Input, Modal, Typography} from "antd";
import React, {useEffect, useRef, useState} from "react";
import Dragable, {DraggableData, DraggableEvent} from "react-draggable";
import '../ModalStyles.scss';
import {FilialModel} from "../../models/FilialModel";
import {filialAPI} from "../../services/FilialService";

const {Text} = Typography;

type ModalProps = {
    infoNotification: Function,
    errorNotification: Function,
    filial: FilialModel,
    setVisible: Function,
    getFilials: Function,
}

export const UpdateFilialModal = (props: ModalProps) => {
    const [updateFilial, {isSuccess: isSuccessUpdateFilial, isError: isErrorUpdateFilial, error: errorUpdateFilial}] = filialAPI.useUpdateFilialMutation();
    const [deleteFilial, {isSuccess: isSuccessDeleteFilial, isError: isErrorDeleteFilial, error: errorDeleteFilial}] = filialAPI.useDeleteFilialMutation();
    // Draggable settings
    const [disabled, setDisabled] = useState<boolean>(false);
    const [bounds, setBounds] = useState({left: 0, top: 0, bottom: 0, right: 0});
    const draggableRef = useRef<HTMLDivElement>(null);
    const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
        const {clientWidth, clientHeight} = window.document.documentElement;
        const targetRect = draggableRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top - uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        })
    }
    // End of dnd
    const [name, setName] = useState<string>(props.filial.name);
    const [code, setCode] = useState<string>(props.filial.code);
    const [modalWidth, ] = useState<number>(500);
    useEffect(() => {
        if (isSuccessUpdateFilial || isSuccessDeleteFilial) {
            props.getFilials()
            props.setVisible(false)
        }
        if (isSuccessUpdateFilial) props.infoNotification("Филиал обновлен")
        if (isSuccessDeleteFilial) props.infoNotification("Филиал удален")
    }, [isSuccessUpdateFilial, isSuccessDeleteFilial])
    useEffect(() => {
        if (isErrorUpdateFilial && errorUpdateFilial) {
            if (errorUpdateFilial.toString() === '400')
                props.errorNotification("Имя и код должны быть уникальными")
            else
                props.errorNotification(JSON.stringify(errorUpdateFilial))
        }
    }, [isErrorUpdateFilial])
    useEffect(() => {
        if (isErrorDeleteFilial && errorDeleteFilial) {
            if (errorDeleteFilial.toString() === '400')
                props.errorNotification("На филиал ссылаются другие объекты")
            else
                props.errorNotification(JSON.stringify(errorDeleteFilial))
        }
    }, [isErrorDeleteFilial])
    const handleUpdateFilial = () => {
        if (name && code) {
            const filial: FilialModel = {
                id: props.filial.id,
                name,
                code,
            };
            updateFilial(filial);
        }
    }
    const handleDeleteFilial = () => {
        if (props.filial.id) deleteFilial(props.filial.id);
    }
    return (
        <Modal
            title={'Редактирование филиала'}
            centered={true}
            open={true}
            footer={[]}
            modalRender={(modal) => (
                // @ts-ignore
                <Dragable
                    disabled={disabled}
                    bounds={bounds}
                    onStart={(event, uiData) => onStart(event, uiData)}
                >
                    <div ref={draggableRef}>{modal}</div>
                </Dragable>
            )}
            width={modalWidth}
            onCancel={() => props.setVisible(false)}
        >
            <div className="modalFlex">
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Имя</Text>
                    <Input value={name} onChange={(e: any) => setName(e.target.value)}/>
                </div>
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Код</Text>
                    <Input value={code} onChange={(e: any) => setCode(e.target.value)}/>
                </div>

                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalButtons">
                    <Button onClick={handleUpdateFilial}>Сохранить</Button>
                    <Button onClick={() => props.setVisible(false)}>Отменить</Button>
                    <Button onClick={handleDeleteFilial} danger>Удалить</Button>
                </div>
            </div>
        </Modal>
    )
}